import React, { Component } from 'react'
import { Row, Col, Table, Image, Button, Container, Accordion, Card, Form, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import { components } from 'react-select'
import * as Cookies from "es-cookie";
import moment from 'moment';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import StudentOrganizationProfileEamcet from '../../components/home/student_organization_profile/studentProfileEamcet';

class PerformanceAnalysisModalEamcet extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() { 
        let row = { contact_no: this.props.data.contact_no, exam_id: this.props.exam_id }
        return (
            <Modal {...this.props} className='refer_modal_Result p-3'
                size="xl" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton className='p-2'>
                </Modal.Header>
                <Modal.Body className='bg-popup'>
                    <StudentOrganizationProfileEamcet
                        hislocationData={row}
                    />
                </Modal.Body>
            </Modal>
        )
    }
}

export default withRouter(compose(

)(PerformanceAnalysisModalEamcet));